import styled from 'styled-components';
import PropTypes from 'prop-types';

const Viewport = styled.div`
  overflow: hidden;
  padding: 5px;
  min-width: ${({ minWidth }) => minWidth};
  min-height: ${({ minHeight }) => minHeight};
  margin: 0 auto;
  ${({ scrollable }) => (scrollable ? '' : 'height: 100%;')}
  ${({ dimmed }) => (dimmed ? 'opacity 0.3;' : 'opacity 1.0;')}
`;

Viewport.propTypes = {
  minWidth: PropTypes.string.isRequired,
  minHeight: PropTypes.string.isRequired,
  scrollable: PropTypes.bool.isRequired,
};

export default Viewport;
